import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useURLSync = (initialFilters) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(() => {
    const urlFilters = {};
    Object.keys(initialFilters).forEach((key) => {
      const value = searchParams.get(key);
      urlFilters[key] = value !== null ? value : initialFilters[key];
    });
    return urlFilters;
  });

  useEffect(() => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== '' && value !== 'all') {
        params.set(key, String(value));
      }
    });
    setSearchParams(params, { replace: true });
  }, [filters, setSearchParams]);

  return [filters, setFilters];
};
